import { render, staticRenderFns } from "./SelectedMarkersTable.vue?vue&type=template&id=c580f2c6&scoped=true&"
import script from "./SelectedMarkersTable.vue?vue&type=script&lang=js&"
export * from "./SelectedMarkersTable.vue?vue&type=script&lang=js&"
import style0 from "./SelectedMarkersTable.vue?vue&type=style&index=0&id=c580f2c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c580f2c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VDataTable,VSpacer,VTooltip})
